import { Box, useMediaQuery } from '@mui/material'
import { ErrorBoundary } from 'components'
import { Outlet, useLocation, matchPath } from 'react-router-dom'
import { NavigationBar, Footer, TopInfoBar } from './components'
import { PageURLs } from 'config'
import MobileBottomNav from './components/MobileBottomNav'
import { mobileMainPaddingBottom } from './constants/mobileNav'

const footerPaths = [
  PageURLs.Home,
  PageURLs.ProductDetails,
  PageURLs.Categories,
  PageURLs.ProductListing,
]

const Main = ({ isSuspense }) => {
  const location = useLocation()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  const withFooter = footerPaths.some((path) => matchPath(path, location.pathname))
  const isProductDetails = Boolean(matchPath(PageURLs.ProductDetails, location.pathname))

  return (
    <ErrorBoundary>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <TopInfoBar />
        <NavigationBar />

        <Box
          component="main"
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            // Bottom padding on mobile so content clears the bottom tab bar
            // (product detail page manages its own spacing for the sticky CTA)
            pb: isMobile && !isProductDetails ? mobileMainPaddingBottom : 0,
          }}
        >
          <Outlet />
        </Box>

        {withFooter && <Footer isMobile={isMobile} />}

        {/* Floating mobile bottom navigation */}
        {isMobile && <MobileBottomNav />}
      </Box>
    </ErrorBoundary>
  )
}

export default Main
